import { Component, OnChanges, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { InprocessQualityIssues, IQIToken, IQIDayToken, DailyTokenItem, DailyToken, subProduct, SeverityStatus } from '../../../shared/misc-classes';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {trigger, transition, style, animate, state} from '@angular/animations';
import { GenService } from '../../../shared/gen-ser.service';
import { DataService } from '../../../shared/dataservice.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-inpr-qual-day-view',
  templateUrl: './inpr-qual-day-view.component.html',
  styleUrls: ['./inpr-qual-day-view.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        state('*', style({'opacity': 1})),
        transition('void => *', [
            style({'opacity': 0}),
            animate('1000ms linear')
        ]),
        transition('* => void', animate(0, style({opacity: 0})))

      ])
    ]
})
export class InprQualDayViewComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() inProcessQualObj:InprocessQualityIssues;  
  @Input() productLineID:string;
  IQIDayTokenObj:IQIDayToken;
  @ViewChild('childModal') public childModal:ModalDirective; 
  @Output() changesFlag = new EventEmitter();
  subProductList:Array<subProduct>=[];

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editDate:Date = new Date();
  editRow:IQIToken;
  editParam1:any;
  editParam2:any;
  severityFlag:boolean = false;
  mId:string = "773881e1-3f3a-49be-865a-1a2f0312be8d";

  public _severityStatus = SeverityStatus;

  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadDateData();
    this.loadSubProducts()

  }
  public addNewProdRow(_newRowToken:string,_dayIndex:number){
    switch(_newRowToken){
      case "newrow":
        this.showChildModal(_newRowToken,null,null);
        this.editType = "newrow";
        this.severityFlag = false;
      break;
    }
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getPS(_id:string):string{
    if(_id)
      return this._dataService.getSubProduct(_id,this.productLineID);
    return ''
  }
  getIssueRelatedTo(_id:string):string{
    if(_id)
      return this._dataService.getIssueRelated(_id)
    return ''
  }
  getDefectCategory(_id:string):string{
    if(_id)
      return this._dataService.getDefectCategory(_id)
    return ''
  }
  getIssueCapturing(_id:string):string{
    if(_id)
      return this._dataService.getIssueCapturing(_id)
    return ''
  }
  getDefectSubCategory1(_id:string):string{
    if(_id)
      return this._dataService.getDefectSubCategory1(_id)
    return ''
  }
  getDefectSubCategory2(_id:string):string{
    if(_id)
      return this._dataService.getDefectSubCategory2(_id)
    return ''
  }
  getDefectSubCategory3(_id:string):string{
    if(_id)
      return this._dataService.getDefectSubCategory3(_id)
    return ''
  }
  getDispositionDecision(_id:string):string{
    if(_id)
      return this._dataService.getDepositionDecision(_id)
    return ''
  }
  getStatus(_id:string):string{
    if(_id)
      return this._dataService.getStatus(_id)
    return ''
  }
  getNCRCapturing(_id:string):string{
    if(_id)
      return this._dataService.getNCRCapturing(_id)
    return ''
  }
  getSupplierName(_id:string):string{
    if(_id)
      return this._dataService.getSupplierName(_id)
    return ''
  }
  getData(option){
    if(option) return option
    return ''
 }
 getResponsiblePrsn(_prsn:string):string{
   if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
   return ''
 }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }
  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }
  formatDate(_date:Date):string{
    if(_date){
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  removeRecord(_tokenIndex:number){
    this.IQIDayTokenObj.removeToken(_tokenIndex);
    this.changesFlag.emit(true);
}

  dataEdited(){
    switch(this.editToken){
      case "rowedit":
      this.severityFlag = true;
        this.editParam1.issueRelated = this.editRow.issueRelated;       
        this.editParam1.productName = this.editRow.productName;
        this.editParam1.productType = this._dataService.getProductLineBasedOnPS(this.editRow.ps);
        this.editParam1.supplierName = this.editRow.supplierName;
        this.editParam1.quantity = this.editRow.quantity;
        this.editParam1.rootCause = this.editRow.rootCause;
        if(this.editRow.targetDate){
          
        this.editParam1.targetDateNum = this.editRow.targetDate.getTime();
        }
        this.editParam1.actionDecided = this.editRow.actionDecided;
        this.editParam1.preventiveAction = this.editRow.preventiveAction;
        this.editParam1.ncrCapturing = this.editRow.ncrCapturing;
        this.editParam1.issueCapturing = this.editRow.issueCapturing;
        this.editParam1.defectCategory = this.editRow.defectCategory;  
        this.editParam1.respPrsn = this.editRow.respPrsn;     
        // this.editParam1.defectSubCategory1 = this.editRow.defectSubCategory1;
        // this.editParam1.defectSubCategory2 = this.editRow.defectSubCategory2;
        // this.editParam1.defectSubCategory3 = this.editRow.defectSubCategory3;
        this.editParam1.defectSubCategory1 = this.editRow.defectSubCategory1;
        this.editParam1.defectSubCategory2= this.editRow.defectSubCategory2;
        this.editParam1.defectSubCategory3 = this.editRow.defectSubCategory3;
        this.editParam1.dispositionDecision = this.editRow.dispositionDecision;
        this.editParam1.status = this.editRow.status;
        this.editParam1.rowId = this.editRow.rowId;
        this.editParam1.shortageNotes = this.editRow.shortageNotes;
        if(this.editRow.createdDate){
          this.editParam1.creationDateNum = this.editRow.createdDate.getTime();
          }
        this.editParam1.severityValue = this.editRow.severityValue;
        this.editParam1.ps = this.editRow.ps
      break;
      case "newrow":
      this.inProcessQualObj.addDateToken(new Date(this.currMonthDtObj),
      new IQIToken(this.editRow.rowId,this.editRow.productName,this._dataService.getProductLineBasedOnPS(this.editRow.ps),this.editRow.ps,this.editRow.productDesc,this.editRow.quantity,this.editRow.issueRelated,
                   this.editRow.supplierName,this.editRow.ncrCapturing,this.editRow.issueCapturing,this.editRow.defectCategory,
                   this.editRow.defectSubCategory1,this.editRow.defectSubCategory2,this.editRow.defectSubCategory3,this.editRow.rootCause,
                   this.editRow.dispositionDecision,this.editRow.actionDecided,this.editRow.preventiveAction,this.editRow.respPrsn,
                   this.editRow.targetDateNum,this.editRow.status,this.editRow.shortageNotes,this.editRow.creationDateNum, this.editRow.severityValue, null));
      break;
      case "date":
        this.inProcessQualObj.monthDate = this.editDate;
        this.currMonthDtObj = this.editDate;
      break
    }
    this.changesFlag.emit(true);
    this.hideChildModal();
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }
  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.editRow = _param1.cloneSelf();
      this.editType = _editToken;
      this.severityFlag = true;
        this.editHeader = "Edit Inprocess Quality Issues (" + this.formatHeaderDate(this.IQIDayTokenObj.selDate) +")";
      break;
      case "newrow":
      this.editRow = new IQIToken(GenService.getGUID(),null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,(new Date()).getTime(),SeverityStatus.Not_A_Concern,null)
      this.editType = _editToken;
      this.editHeader = "Add Inprocess Quality Issues (" + this.formatHeaderDate(this.IQIDayTokenObj.selDate) +")";
      break;
      case "date":
        this.editDate = this.inProcessQualObj.monthDate;
        this.editType = 'date';
        this.editHeader = "Edit Date";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  loadSubProducts(){
    this.subProductList = [];
    for(var i=0;i<this._dataService.subProduct.length;i++){
      if(this._dataService.subProduct[i].productId == this.productLineID){
        this.subProductList.push(this._dataService.subProduct[i])
      }
    }
    return this.subProductList;
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }
  loadDateData():void{
    let _tmpDPHDayToken:IQIDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.inProcessQualObj.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.inProcessQualObj.getDateToken(this.currMonthDtObj);
    }
    this.IQIDayTokenObj = _tmpDPHDayToken;
  }
  public hideChildModal():void {
    this.childModal.hide();
  }

  public discardSaveData():void {
      this.childModal.hide();
  }
  severityClicked(editRow,option){
     this.severityFlag = true;
     this.editRow.severityValue = option;
  
  }
}
